import { useUi, isHidden } from "@/lib/uiConfig";

export const Vis = ({ id, children }) => {
  const c = useUi();
  return isHidden(c, id) ? null : children;
};
